import {
  getBaseApiHelper,
  postBaseApiHelper,
  patchBaseApiHelper,
  deleteBaseApiHelper
} from '../../common/utils/apiHelpers';

export const GET_ACCOUNT_FIELDS_REQUEST = 'GET_ACCOUNT_FIELDS_REQUEST';
export const GET_ACCOUNT_FIELDS_FAILURE = 'GET_ACCOUNT_FIELDS_FAILURE';
export const GET_ACCOUNT_FIELDS_SUCCESS = 'GET_ACCOUNT_FIELDS_SUCCESS';
export const SELECT_FIELD_FOR_DETAIL = 'SELECT_FIELD_FOR_DETAIL';

export const FIELD_POST_REQUEST = 'FIELD_POST_REQUEST';
export const FIELD_POST_SUCCESS = 'FIELD_POST_SUCCESS';
export const FIELD_POST_FAILURE = 'FIELD_POST_FAILURE';

export const FIELD_PATCH_REQUEST = 'FIELD_PATCH_REQUEST';
export const FIELD_PATCH_SUCCESS = 'FIELD_PATCH_SUCCESS';
export const FIELD_PATCH_FAILURE = 'FIELD_PATCH_FAILURE';

export const DELETE_FIELD_REQUEST = 'DELETE_FIELD_REQUEST';
export const DELETE_FIELD_SUCCESS = 'DELETE_FIELD_SUCCESS';
export const DELETE_FIELD_FAILURE = 'DELETE_FIELD_FAILURE';

export const GET_FIELD_MAP_REQUEST = 'GET_FIELD_MAP_REQUEST'
export const GET_FIELD_MAP_SUCCESS = 'GET_FIELD_MAP_SUCCESS'
export const GET_FIELD_MAP_FAILURE = 'GET_FIELD_MAP_FAILURE'

// Action Creators

export const selectFieldForDetail = fieldId => ({
  type: SELECT_FIELD_FOR_DETAIL,
  fieldId
});

const getAccountFieldsRequest = () => ({
  type: GET_ACCOUNT_FIELDS_REQUEST,
  isFetching: true
});

const getAccountFieldsSuccess = payload => ({
  type: GET_ACCOUNT_FIELDS_SUCCESS,
  payload
});

const getAccountFieldsFailure = payloadError => ({
  type: GET_ACCOUNT_FIELDS_FAILURE,
  error: payloadError
});

export const getAccountFields = (acctId) => {
  return dispatch => {
    dispatch(getAccountFieldsRequest());
    return getBaseApiHelper(`/account/${acctId}/fields`)
      .then(response => {
        return dispatch(getAccountFieldsSuccess(response.data));
      })
      .catch(rejected => {
        dispatch(getAccountFieldsFailure(rejected.response));
        return Promise.reject({ error: rejected.response });
      });
  };
}


const fieldPostRequest = () => ({
  type: FIELD_POST_REQUEST,
  isFetching: true
});

const fieldPostSuccess = payload => ({
  type: FIELD_POST_SUCCESS,
  payload
});

const fieldPostFailure = payloadError => ({
  type: FIELD_POST_FAILURE,
  error: payloadError
});

export const createField = ({
  name, account_id, boundary, current_crop, previous_crop, farm_id
}) => {
  return dispatch => {
    dispatch(fieldPostRequest());
    return postBaseApiHelper('/fields', {
      name,
      account_id,
      farm_id,
      boundary,
      current_crop,
      previous_crop
    })
      .then(response => {
        return dispatch(fieldPostSuccess(response.data));
      })
      .catch(rejected => {
        dispatch(fieldPostFailure(rejected.response));
        return Promise.reject({ error: rejected.response });
      });
  };
}

const fieldPatchRequest = () => ({
  type: FIELD_PATCH_REQUEST,
  isFetching: true
});

const fieldPatchSuccess = payload => ({
  type: FIELD_PATCH_SUCCESS,
  payload
});

const fieldPatchFailure = payloadError => ({
  type: FIELD_PATCH_FAILURE,
  error: payloadError
});

export const updateField = (fieldId, {
  name, account_id, boundary, current_crop, previous_crop, farm_id
}) => {
  return dispatch => {
    dispatch(fieldPatchRequest());
    return patchBaseApiHelper(`/fields/${fieldId}`, {
      name,
      boundary,
      account_id,
      farm_id,
      current_crop,
      previous_crop
    })
      .then(response => {
        return dispatch(fieldPatchSuccess(response.data));
      })
      .catch(rejected => {
        dispatch(fieldPatchFailure(rejected.response));
        return Promise.reject({ error: rejected.response });
      });
  };
}

const deleteFieldRequest = () => {
  return {
    type: DELETE_FIELD_REQUEST,
    isFetching: true
  };
}

const deleteFieldSuccess = fieldId => ({
  type: DELETE_FIELD_SUCCESS,
  fieldId
});

const deleteFieldFailure = payloadError => ({
  type: DELETE_FIELD_FAILURE,
  error: payloadError
});

export const deleteField = fieldId => {
  return dispatch => {
    dispatch(deleteFieldRequest());
    return deleteBaseApiHelper(`/fields/${fieldId}`)
      .then(() => {
        return dispatch(deleteFieldSuccess(fieldId));
      })
      .catch(rejected => {
        dispatch(deleteFieldFailure(rejected.response));
        return Promise.reject({ error: rejected.response })
      });
  };
}

const getFieldMapRequest = () => ({
  type: 'GET_FIELD_MAP_REQUEST'
})

const getFieldMapSuccess = (field, key, payload) => ({
  type: 'GET_FIELD_MAP_SUCCESS',
  fieldId: field,
  key,
  payload
})

const getFieldMapFailure = (errorPayload) => ({
  type: 'GET_FIELD_MAP_FAILURE',
  error: errorPayload
})


export const getFieldMap = (fieldId, crop, indicator, startDate, endDate)=>{
  return dispatch => {
    dispatch(getFieldMapRequest());
    return getBaseApiHelper(`/maps` +
    `?field=${fieldId}` +
    `&crop=${crop}` +
    `&indicator=${indicator}` +
    `&start=${startDate}` +
    `&end=${endDate}`
    )
      .then((payload) => {
        return dispatch(getFieldMapSuccess(fieldId, crop+indicator+startDate+endDate, payload));
      })
      .catch(rejected => {
        dispatch(getFieldMapFailure(rejected.response));
      });
  };
}
